<template>
  <div class="tarjeta">
    <div class="container-logo">
      <v-icon size="x-large" color="primary">chat</v-icon>
    </div>
    <div class="container-titulo">
      <span>{{ titulo }}</span>
    </div>
    <div class="departamento">
      <!-- <v-icon size="x-large" color="676767">event</v-icon>
      <span><b>{{ created }}</b></span>
      <br> -->
      <!-- <v-icon size="x-large" color="676767">mdi-email</v-icon> -->
      <div @click="goDetail" class="tarjeta-selection">
        <v-icon color="black">mdi-chevron-right</v-icon>
    </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      fecha: null,
      hora: null
    }
  },
  props: {
    autor: null,
    createdAt: null,
    clubId: null,
    partidoDescription: null,
    partidoId: null,
    departamento: null,
    estado: null,
    detailId: null,
    reportType: null,
    cardType: null,
    modified: null,
    titulo: null,
    logo: null,
    cantidadRespuestas: null,
    created: null,
    tabActiva: null,
    mensajes: null
  },
  methods: {
    goDetail () {
      const chatId = this.detailId
      this.$emit('clickDetalleChat', chatId, this.mensajes)
    }
  },
  created () {

  }
}
</script>

<style scoped>
.tarjeta{
  background-color: #eeeeee;
  width: 90%;
  height: 70px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  flex-direction: row;
  overflow: hidden;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  margin: 20px auto;
}

.container-logo{
  display: flex;
  margin-left: 20px;
}

.autor-name{
  margin-left: 6px;
  align-self: center;
}

.departamento{
  margin-left: auto;
  margin-right: 10px;
  max-width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  justify-content: center;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  gap: 5px;
}

span{
  font-size: 1.2em;
  color: #293968;
}

.container-titulo{
  flex: 1;
  min-width: 0;
  margin-left: 15px;
  margin-right: 55px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tarjeta-selection{
  margin-right: 10px;
  cursor: pointer;
}

</style>
